import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import Avatar from "components/Avatar";
import Badge from "components/Badge";
import { Translate } from "utils";

import styles from "./DropdownItem.css";

const { t } = new Translate("DropdownUserItem");

const DropdownUserItem = ({ currentUser, isSelected, value }) => (
  <button className={cx(styles.item, { [styles.selected]: isSelected })}>
    <div className={styles.addonLeft}>
      <Avatar fname={value.fname} lname={value.lname} size="small" src={value.profilePictureUrl} />
    </div>
    <div className={styles.label}>
      {value.fname} {value.lname}
    </div>
    {currentUser.id === value.id && (
      <div className={styles.badge}>
        <Badge isSmall>{t("me")}</Badge>
      </div>
    )}
  </button>
);

DropdownUserItem.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.number,
  }),
  isSelected: PropTypes.bool,
  value: PropTypes.shape({
    id: PropTypes.number,
    fname: PropTypes.string,
    lname: PropTypes.string,
    profilePictureUrl: PropTypes.string,
  }),
};

export default DropdownUserItem;
